import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { cleanIsbd } from '../../../../shared/pipes/clean-isbd';
import { BrowseIndexItem } from '../../models';

/**
 * IndexCard — Presentation Component
 *
 * Displays a single catalog item as a card with cover image,
 * title, author, and Hijri date. Pure @Input, no services.
 *
 * Used inside the results grid of BrowseIndexPageComponent.
 */
@Component({
  selector: 'app-index-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './index-card.component.html',
  styleUrl: './index-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndexCardComponent {
  /** The catalog item to display */
  @Input({ required: true }) item!: BrowseIndexItem;

  /** Fallback image when cover is unavailable */
  readonly fallbackImage = 'images/custom/lib-cover-3.jpg';

  get formattedTitle(): string {
    return cleanIsbd(this.item?.title);
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = this.fallbackImage;
  }
}
